const BaseContainer = ({ className, children }: any) => {
  return (
    <div className={`container mx-auto px-4 w-full ${className}`}>
      {children}
    </div>
  );
};

export default BaseContainer;
